<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <section class="mu-d-flex mu-flex-row mu-align-items-center">
                <h1 class="mu-mb-00">Forms</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li aria-current="page">Forms</li>
            </ol>
        </nav>

        <Drawer ref="customFilter" @reset-filter="resetForm" @apply-filter="submitDialog($event)" title="Form Filters">
       
                <section>
                    <div>
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <form id="formIdd">
                                <div>
                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                        <label for="name" class="mu-mb-00">Name</label>
                                        <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="formNameRef" @change="formNameRef = $event.target.value">

                                    </div>
                                    <div class="mfc-slim-select-wrapper mu-mb-03">
                                        <label for="application-selectId" class="mu-mb-00">Applications</label>
                                        <select id="application-selectId" @change="selectedApplicationRef = $event.target.value" ref="dropdownRef" name="application-select" block>
                                            <option data-placeholder="true"></option>
                                            <option v-for="(app,key) in applications" :selected="selectedApplicationRef == app.id" :key="key" :value="app.id">{{app.name}}</option>
                                        </select>
                                    </div>
                                    <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                        <fieldset class="mfc-fieldset">
                                            <legend class="mfc-label">
                                                Disabled
                                            </legend>
                                            <div class="mcc-segmented-buttons__list" ref="radioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                                                <input type="radio" name="deleted" value="deleted" id="deleted" @click="formTypeRef = $event.target.value" :checked="formTypeRef =='deleted'">
                                                <label class="mcc-segmented-buttons__button" for="deleted">
                                                    <span class="mcc-segmented-buttons__label">Yes</span>
                                                </label>
                                                <input type="radio" name="active" value="active" id="active" @click="formTypeRef = $event.target.value" :checked="formTypeRef =='active'">
                                                <label class="mcc-segmented-buttons__button" for="active">
                                                    <span class="mcc-segmented-buttons__label">No</span>
                                                </label>
                                                <input type="radio" name="All" value=" " id="All" @click="formTypeRef = $event.target.value" :checked="formTypeRef ==' '">
                                                <label class="mcc-segmented-buttons__button" for="All">
                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                </label>

                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                </form>

                            </div>

                        </div>
                    </div>
                </section>
           
        </Drawer>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-row" v-if="fetchCall">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                </button>
                            </div>
                            <div>
                                <div>
                                    <div class="mcc-table-toolbar" v-show="selectedForm.length>0">
                                        <div class="mcc-table-batch-actions mcc-table-batch-actions--active">
                                            <div class="mcc-table-batch-actions__summary">
                                                <p class="mu-mb-00">{{selectedForm.length}} {{ selectedForm.length > 1 ? 'rows selected' : 'row selected'}}</p>
                                            </div>
                                            <div class="mcc-table-batch-actions__list">
                                                <div class="mcc-button-group mcc-button-group--spaced">
                                                    <button class="mcc-button mcc-button mu-border mu-border-ui-01" @click="copyForms" id="copyFormBtn" title="Copy forms" v-show="selectedForm.length>0">
                                                        <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label"></span>
                                                        Copy Forms
                                                    </button>
                                                    <button id="cancelBtn" class="mcc-button mcc-button--icon-only mcc-button--sm mcc-button--primary" @click="uncheckAll">
                                                        <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
                                                        <span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mcc-data-table ref="appFormList" id="appFormListId"></mcc-data-table>
                            <mcc-icon class="d-none" name="edit"></mcc-icon>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
</template>

<script>
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "ApplicationForms",
    components: {
        Drawer
    },
    data() {
        return {
            searchCriteria: {},
            nameRegex: constantMessages.PATTERNS["name"],
            applications: {},
            selectedApplicationRef: "",
            selectedApplication: "",
            updateDialog: false,
            formName: "",
            formType: "active",
            formNameRef: "",
            formTypeRef: "active",
            selectedForm: [],
            tableObj: null,
            currentPageSize: 10,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["application.form.list"],
            updateCall: true,
            responseData: [],
            appToCopyId: "",
            pageStart: -1,
            fetchCall: false,
            tableData: [],
            filterActive: false,
            filterData: [],
            selectInstanceEntities: null,
            filterCount: 0,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (this.$route.params.otherProps != undefined) {
            this.appToCopyId = this.$route.params.otherProps.appToCopyId;
        }
        if (localStorage.getItem("FormList") === "FormList") {
            this.formTypeRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_formType"
            );
            this.formType = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_formType"
            );
            this.selectedApplication = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
            this.selectedApplicationRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
            this.formNameRef = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_formName"
            );
            this.formName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_formName"
            );
            this.currentPageSize = parseInt(
                localStorage.getItem("FormListPageSize")
            );
            localStorage.removeItem("FormListPageSize");
            localStorage.removeItem("FormList");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_formName"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_formType"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedApplication"
            );
        }

        ApplicationFormAPI.getApplications()
            .then(result => {
                self.applications = result;
                self.fetchCall = true;
            })
            .finally(() => {
                self.initFormTable();
                this.selectInstanceEntities = new SlimSelect({
                    select: '#application-selectId'
                })
            });
    },
    methods: {
        getFilterCount() {
            if (this.selectedApplicationRef != "")
                this.filterCount += 1;
            if (this.formNameRef != "")
                this.filterCount += 1;
            if (this.formTypeRef != "")
                this.filterCount += 1;
        },
        resetForm() {
            this.filterCount = 0;
            this.updateCall = false;
            this.formTypeRef = "active";
            this.selectedApplicationRef = "";
            this.formNameRef = "";
            this.selectedApplication = "";
            this.formName = "";
            this.formType = "active";
            this.resetSlimSelect();
            this.initFormTable();
            this.$refs.radiogroupNo.checked = true
        },
        resetSlimSelect() {
            this.selectInstanceEntities.setSelected('')
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedApplication = this.selectedApplicationRef;
            this.formName = this.formNameRef;
            this.formType = this.formTypeRef;
            this.initFormTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        initFormTable() {
            let self = this;
            self.selectedForm = [];
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#appFormListId');
            self.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No application forms found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                fixedHeight: true,
                schema: {
                    properties: {
                        select: {
                            type: "boolean",
                            format: "checkbox",
                            title: "Select",
                            editable: true
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="table-link" data-id="{{id}}" data-app-id={{applicationId}}>{{name}}</a>',
                            sortable: true
                        },
                        formDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false
                        },
                        version: {
                            type: "string",
                            title: "Version",
                            sortable: false
                        },
                        applicationName: {
                            type: "string",
                            title: "Application name",
                            template: '<a class="name-link" data-id="{{applicationId}}">{{applicationName}}</a>',
                            sortable: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        self.pageStart = start;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&formName=" +
                            self.formName +
                            "&currentAppId=" +
                            self.selectedApplication +
                            "&processType=" +
                            self.formType.trim();
                        return ApplicationFormAPI.getForms(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                result.data.forEach(resultField => {
                                    resultField.select =
                                        self.selectedForm.indexOf(resultField.id) != -1;
                                    resultField["disabledCheckbox"] = resultField.formDisabled == "Yes" || resultField.applicationDisabled;

                                });
                                responseData.data = result.data;
                            }

                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;

                    }
                },
                onAction: (table, action, rowObj) => {
                    if (action == "select") {
                        rowObj.forEach((obj, a) => {
                            if (obj.value && self.selectedForm.indexOf(obj.rowData.id) == -1) {
                                self.selectedForm.push(obj.rowData.id);
                            } else if (!obj.value && obj.rowData.formDisabled == "No" && obj.rowData.formApplication.deleted == null) {
                                self.selectedForm.splice(self.selectedForm.indexOf(obj.rowData.id), 1);
                            }
                        });
                    }
                },
                onAfterDataLoad: (filesTable, start, limit) => {
                    self.responseData.forEach((item, index) => {
                        if (item.disabledCheckbox) {
                            filesTable.disableRowActions(self.pageStart + index);
                        }
                    });
                    self.updateTemplate();
                    self.updateCall = true;
                }
            });
        },
        updateTemplate() {
            let self = this;
            this.$refs.appFormList
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/design/applications/" + reference.trim()
                            );
                        }
                    });
                });

            this.$refs.appFormList
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            let appId = $(targetEle).attr("data-app-id");
                            self.$router.push({
                                path: self.CONTEXT_PATH +
                                    "/design/applications/" +
                                    appId.trim() +
                                    "/appforms/" +
                                    reference.trim(),
                                query: {
                                    path: "form"
                                }
                            });
                        }
                    });
                });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                "FormListPageSize",
                this.tableObj.tableContext.store.state.pageSize
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_formType",
                this.formType
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedApplication",
                this.selectedApplication
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_formName",
                this.formName
            );
        },
        copyForms() {
            this.setFilterDataInLocalStorage();
            this.$router.push({
                path: this.CONTEXT_PATH +
                    "/design/applications/appforms/copy",
                name: "MultipleFormCopy",
                params: {
                    otherProps: {
                        formIds: this.selectedForm,
                        appToCopyId: this.appToCopyId
                    }
                }
            });
        },
        uncheckAll() {
            let self = this;
            const selectedList = document.querySelectorAll("#appFormListId input[type=checkbox]:checked");

            selectedList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            self.selectedForm = [];
        },

    }
};
</script>
